(() => {
  const root = document.getElementById('tl-urgency-root');
  if (!root) return;

  const DISCOUNT_CODE = root.dataset.discountCode || 'TEKRAR10';
  const DISCOUNT_PERCENT = root.dataset.discountPercent || '10';
  const OFFER_DURATION = 24 * 60 * 60 * 1000;
  const CYCLE_DURATION = 48 * 60 * 60 * 1000;
  const CYCLE_SIZE = 12;
  const now = Date.now();

  const getNum = key => Number(localStorage.getItem(key) || 0);

  const legacyOfferReason = localStorage.getItem('tl_offer_reason');
  if (legacyOfferReason === 'cart_added' || legacyOfferReason === 'campaign_cart') {
    localStorage.removeItem('tl_offer_start');
    localStorage.removeItem('tl_offer_reason');
    localStorage.removeItem('tl_offer_expired');
    localStorage.removeItem('tl_discount_applied');
  }
  const hasExpiredPersonal = () => localStorage.getItem('tl_offer_expired') === '1';
  const getPersonalStart = () => getNum('tl_offer_start');
  const getPersonalExpiry = () => {
    const start = getPersonalStart();
    return start ? start + OFFER_DURATION : 0;
  };
  const personalIsActive = () => {
    const expiry = getPersonalExpiry();
    return expiry && Date.now() < expiry;
  };

  let visits = getNum('tl_visit_count');
  try {
    if (!sessionStorage.getItem('tl_session_seen')) {
      visits += 1;
      localStorage.setItem('tl_visit_count', String(visits));
      sessionStorage.setItem('tl_session_seen', '1');
    }
  } catch {
    if (!getNum('tl_last_activity')) {
      visits += 1;
      localStorage.setItem('tl_visit_count', String(visits));
    }
  }
  localStorage.setItem('tl_last_activity', String(now));

  const currentHandle = root.dataset.productHandle || '';
  let selectedHandles = [];
  let selectedProducts = [];
  let cycleExpiry = (Math.floor(now / CYCLE_DURATION) + 1) * CYCLE_DURATION;
  let cartMountBusy = false;
  let ourDiscountApplied = localStorage.getItem('tl_discount_applied') === '1';

  function pushEvent(name, extra = {}) {
    const payload = { event: 'tablissa_urgency', tl_event: name, ...extra };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent('tablissa:urgency', { detail: payload }));
  }

  function startPersonalOffer(reason) {
    if (personalIsActive() || hasExpiredPersonal()) return false;
    const start = Date.now();
    localStorage.setItem('tl_offer_start', String(start));
    localStorage.setItem('tl_offer_reason', reason);
    pushEvent('personal_offer_started', { visits, reason });
    renderGlobalBar();
    hydrateHomeCampaign();
    hydrateMainProductPrice();
    mountProductOffer(true);
    mountCartOffer(true);
    return true;
  }

  if (visits >= 2 && !personalIsActive() && !hasExpiredPersonal()) {
    startPersonalOffer('second_session');
  }

  if (getPersonalExpiry() && Date.now() >= getPersonalExpiry()) {
    localStorage.setItem('tl_offer_expired', '1');
    localStorage.removeItem('tl_offer_start');
  }

  function discountUrl(redirectPath = location.pathname + location.search) {
    return '/discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=' + encodeURIComponent(redirectPath);
  }

  function formatTime(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
  }

  function formatTry(value) {
    const amount = Number(value || 0);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(amount);
  }

  let tlResolvedVariantId = Number(new URL(window.location.href).searchParams.get('variant') || 0);
  let tlResolvedPriceCents = 0; // Used only for the custom-size price event.
  let tlPriceRenderGeneration = 0;

  window.TablissaUrgencyPricing = {
    isActive: () => personalIsActive(),
    percent: Number(DISCOUNT_PERCENT),
    discountedCents: (cents) =>
      Math.round(Number(cents || 0) * (1 - Number(DISCOUNT_PERCENT) / 100))
  };

  function getResolvedVariantId(productTarget = null) {
    const customPanel = document.querySelector('.tablissa-custom-size__panel:not([hidden])');
    if (customPanel && tlResolvedVariantId) return tlResolvedVariantId;

    const component =
      (productTarget instanceof HTMLElement && productTarget.matches('product-form-component'))
        ? productTarget
        : productTarget?.closest?.('product-form-component') ||
          document.querySelector('product-form-component');
    const formId = Number(component?.querySelector('input[name="id"]')?.value || 0);
    if (formId) return formId;
    return Number(new URL(window.location.href).searchParams.get('variant') || 0);
  }

  async function getCurrentVariantPricing(productTarget = null) {
    if (!currentHandle) return null;
    const variantId = getResolvedVariantId(productTarget);
    if (!variantId) return null;

    try {
      const customOpen = !!document.querySelector('.tablissa-custom-size__panel:not([hidden])');
      let priceCents = 0;

      // The custom-size pricing event supplies its authoritative selected price.
      if (customOpen && variantId === tlResolvedVariantId && tlResolvedPriceCents > 0) {
        priceCents = tlResolvedPriceCents;
      } else {
        // Fetch afresh: never reuse product JSON or prices cached before a Shopify price edit.
        const response = await fetch('/products/' + encodeURIComponent(currentHandle) + '.js', {
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (!response.ok) return null;
        const productData = await response.json();
        const variant = (productData?.variants || []).find(v => Number(v.id) === variantId);
        if (!variant) return null;
        priceCents = Number(variant.price || 0);
      }

      if (!Number.isFinite(priceCents) || priceCents <= 0) return null;
      const oldPrice = priceCents / 100;
      const newPrice = Math.round(priceCents * (1 - Number(DISCOUNT_PERCENT) / 100)) / 100;
      return { oldPrice, newPrice, saving: oldPrice - newPrice, variantId };
    } catch {
      return null;
    }
  }

  async function hydrateMainProductPrice(productTarget = null) {
    const renderGeneration = ++tlPriceRenderGeneration;
    const priceHost =
      document.querySelector('main product-price') ||
      document.querySelector('product-price');

    const nativePrice = priceHost?.querySelector('[ref="priceContainer"]');
    if (!(nativePrice instanceof HTMLElement)) return;

    const pricing = await getCurrentVariantPricing(productTarget);
    if (!pricing || renderGeneration !== tlPriceRenderGeneration || pricing.variantId !== getResolvedVariantId(productTarget) || !nativePrice.isConnected) return;

    // Never create sibling price blocks: write into the theme's real price container.
    if (!personalIsActive()) {
      nativePrice.innerHTML = '<span class="price">' + formatTry(pricing.oldPrice) + '</span>';
      nativePrice.removeAttribute('data-tl-discount-rendered');
      return;
    }

    nativePrice.innerHTML =
      '<div class="tl-main-offer-price">' +
        '<span class="tl-main-offer-price__old">' + formatTry(pricing.oldPrice) + '</span>' +
        '<strong class="tl-main-offer-price__new">' + formatTry(pricing.newPrice) + '</strong>' +
        '<span class="tl-main-offer-price__badge">%' + DISCOUNT_PERCENT + ' SİZE ÖZEL</span>' +
      '</div>';
    nativePrice.setAttribute('data-tl-discount-rendered', String(pricing.variantId));
  }

  async function clearMainProductPrice(productTarget = null) {
    const priceHost =
      document.querySelector('main product-price') ||
      document.querySelector('product-price');
    const nativePrice = priceHost?.querySelector('[ref="priceContainer"]');
    if (!(nativePrice instanceof HTMLElement)) return;

    const pricing = await getCurrentVariantPricing(productTarget);
    if (!pricing || pricing.variantId !== getResolvedVariantId(productTarget) || !nativePrice.isConnected) return;

    nativePrice.innerHTML = '<span class="price">' + formatTry(pricing.oldPrice) + '</span>';
    nativePrice.removeAttribute('data-tl-discount-rendered');
  }

  async function hydrateProductOfferPricing(card, productTarget = null) {
    if (!card || !personalIsActive()) return;
    const pricing = await getCurrentVariantPricing(productTarget);
    if (!pricing || !document.contains(card) || pricing.variantId !== getResolvedVariantId(productTarget)) return;

    const box = card.querySelector('[data-tl-offer-price-box]');
    const oldPrice = card.querySelector('[data-tl-offer-old-price]');
    const newPrice = card.querySelector('[data-tl-offer-new-price]');
    const saving = card.querySelector('[data-tl-offer-saving]');

    if (oldPrice) oldPrice.textContent = formatTry(pricing.oldPrice);
    if (newPrice) newPrice.textContent = formatTry(pricing.newPrice);
    if (saving) saving.textContent = formatTry(pricing.saving) + ' tasarruf';
    if (box) box.hidden = false;
  }

  function cloneOfferCard(mode, expiry, context = 'default', productTarget = null) {
    const tpl = document.getElementById('tl-offer-card-template');
    if (!tpl) return null;
    const node = tpl.content.firstElementChild.cloneNode(true);
    const eyebrow = node.querySelector('[data-tl-offer-eyebrow]');
    const title = node.querySelector('[data-tl-offer-title]');
    const copy = node.querySelector('[data-tl-offer-copy]');
    const timer = node.querySelector('[data-tl-countdown]');
    const button = node.querySelector('[data-tl-apply-offer]');

    if (mode === 'personal') {
      eyebrow.textContent = 'SİZE ÖZEL · 24 SAAT';
      title.textContent = 'Size özel %' + DISCOUNT_PERCENT + ' indirim aktif';
      copy.textContent = 'İndirim seçili ürüne otomatik uygulanır. Aşağıdaki özel fiyatı ödersiniz.';
    } else {
      eyebrow.textContent = '48 SAATLİK SEÇKİ';
      title.textContent = 'Bu eser şu an %' + DISCOUNT_PERCENT + ' kampanya döngüsünde';
      copy.textContent = 'Seçili eserler 48 saatte bir otomatik olarak yenilenir.';
    }

    button.href = discountUrl();
    if (context === 'cart') {
      button.textContent = '%' + DISCOUNT_PERCENT + ' avantajı uygula ve ödemeye geç';
      button.href = '/checkout';
      button.addEventListener('click', async event => {
        event.preventDefault();
        if (button.dataset.loading === '1') return;
        button.dataset.loading = '1';
        button.textContent = 'Avantaj uygulanıyor...';
        pushEvent('discount_apply_click', { mode, context: 'cart' });

        try {
          const offerReason = localStorage.getItem('tl_offer_reason') || mode;
          const offerStartedAt = localStorage.getItem('tl_offer_start') || '';
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              discount: DISCOUNT_CODE,
              sections: 'cart-drawer-section',
              sections_url: window.location.pathname,
              attributes: {
                '_tl_offer_source': offerReason,
                '_tl_campaign_cycle': String(Math.floor(Date.now() / CYCLE_DURATION)),
                '_tl_offer_started_at': offerStartedAt
              }
            })
          });

          if (!response.ok) throw new Error('discount_apply_failed');

          const updatedCart = await response.json();
          localStorage.setItem('tl_discount_applied', '1');
          document.querySelectorAll('.tl-offer-card--cart').forEach(n => n.remove());
          pushEvent('discount_applied', { mode, totalDiscount: updatedCart.total_discount || 0 });
          window.location.assign('/checkout');
        } catch {
          window.location.assign(discountUrl('/checkout'));
        }
      });
    } else if (context === 'product') {
      button.textContent = '%' + DISCOUNT_PERCENT + ' indirimle sepete ekle';
      button.href = '#';

      button.addEventListener('click', async event => {
        event.preventDefault();
        event.stopPropagation();
        if (button.dataset.loading === '1') return;

        const productFormComponent =
          (productTarget instanceof HTMLElement && productTarget.matches('product-form-component'))
            ? productTarget
            : productTarget?.closest?.('product-form-component') ||
              document.querySelector('product-form-component');

        const form =
          productFormComponent?.querySelector('form[data-type="add-to-cart-form"]') ||
          productFormComponent?.querySelector('form') ||
          document.querySelector('form[data-type="add-to-cart-form"]');

        if (!(form instanceof HTMLFormElement)) {
          pushEvent('discount_apply_error', { mode, context: 'product', message: 'product_form_not_found' });
          return;
        }

        button.dataset.loading = '1';
        button.textContent = 'Sepete ekleniyor...';
        pushEvent('discount_apply_click', { mode, context: 'product' });

        try {
          const formData = new FormData(form);
          const variantId = formData.get('id');

          if (!variantId) throw new Error('variant_not_found');

          formData.set('sections', 'cart-drawer-section');
          formData.set('sections_url', window.location.pathname);

          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' },
            body: formData
          });

          const addResult = await addResponse.json();
          if (!addResponse.ok || addResult?.status) {
            throw new Error(addResult?.description || addResult?.message || 'cart_add_failed');
          }

          const offerReason = localStorage.getItem('tl_offer_reason') || 'second_session';
          const offerStartedAt = localStorage.getItem('tl_offer_start') || '';

          const discountResponse = await fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              discount: DISCOUNT_CODE,
              sections: 'cart-drawer-section',
              sections_url: window.location.pathname,
              attributes: {
                '_tl_offer_source': offerReason,
                '_tl_campaign_cycle': String(Math.floor(Date.now() / CYCLE_DURATION)),
                '_tl_offer_started_at': offerStartedAt
              }
            })
          });

          if (!discountResponse.ok) throw new Error('discount_apply_failed');

          const discountedCart = await discountResponse.json();

          localStorage.setItem('tl_discount_applied', '1');
          ourDiscountApplied = true;
          document.querySelectorAll('.tl-offer-card--product,.tl-offer-card--cart').forEach(n => n.remove());

          const bar = root.querySelector('[data-tl-bar]');
          if (bar) bar.hidden = true;

          pushEvent('discount_applied', {
            mode,
            context: 'product',
            variantId: String(variantId),
            totalDiscount: discountedCart.total_discount || 0
          });

          await refreshCartDrawerHtml(discountedCart?.sections?.['cart-drawer-section'] || null);
        } catch (error) {
          button.dataset.loading = '0';
          button.textContent = '%' + DISCOUNT_PERCENT + ' indirimle sepete ekle';
          pushEvent('discount_apply_error', {
            mode,
            context: 'product',
            message: String(error?.message || error)
          });
        }
      });
    } else {
      button.addEventListener('click', () => pushEvent('discount_apply_click', { mode, context }));
    }
    if (timer) timer.dataset.expiry = String(expiry);
    return node;
  }

  function cleanupDuplicates(selector) {
    const nodes = [...document.querySelectorAll(selector)];
    nodes.slice(1).forEach(node => node.remove());
  }

  function mountProductOffer(force = false) {
    if (!currentHandle) return;
    cleanupDuplicates('.tl-offer-card--product');

    if (ourDiscountApplied) {
      document.querySelectorAll('.tl-offer-card--product').forEach(n => n.remove());
      return;
    }

    const activePersonal = personalIsActive();
    const mode = activePersonal ? 'personal' : null;
    if (!mode) {
      if (force) document.querySelectorAll('.tl-offer-card--product').forEach(n => n.remove());
      return;
    }

    const existing = document.querySelector('.tl-offer-card--product');
    if (existing && existing.dataset.mode === mode) return;
    if (existing) existing.remove();

    const target = document.querySelector('product-form-component') || document.querySelector('form[action*="/cart/add"]');
    if (!target) return;

    const expiry = mode === 'personal' ? getPersonalExpiry() : cycleExpiry;
    const card = cloneOfferCard(mode, expiry, 'product', target);
    if (!card) return;
    card.classList.add('tl-offer-card--product');
    card.dataset.mode = mode;
    target.parentElement?.insertBefore(card, target);
    hydrateProductOfferPricing(card, target);
    hydrateMainProductPrice(target);
    pushEvent('product_offer_shown', { mode, handle: currentHandle });
  }

  async function getCart() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!r.ok) return null;
      return await r.json();
    } catch {
      return null;
    }
  }

  async function refreshCartDrawerHtml(sectionHtml = null) {
    let html = sectionHtml;

    if (!html) {
      const response = await fetch('/?sections=cart-drawer-section&_=' + Date.now(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) throw new Error('cart_drawer_section_fetch_failed');

      const sections = await response.json();
      html = sections?.['cart-drawer-section'];
    }

    if (!html) throw new Error('cart_drawer_section_missing');

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = doc.querySelector('#cart-drawer');
    const currentDrawer = document.querySelector('#cart-drawer');

    if (!freshDrawer || !currentDrawer) {
      throw new Error('cart_drawer_parse_failed');
    }

    currentDrawer.replaceWith(freshDrawer);

    await customElements.whenDefined('theme-drawer');
    await customElements.whenDefined('cart-drawer-component');
    await customElements.whenDefined('cart-items-component');

    const drawer = document.querySelector('#cart-drawer');
    const items = drawer?.querySelector('.cart-drawer__items');
    if (items instanceof HTMLElement) items.scrollTop = 0;

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    const icon = document.querySelector('.header-actions__cart-icon');
    const trigger = icon?.closest('a, button');
    if (trigger instanceof HTMLElement) trigger.click();
    return true;
  }

  function cartHasOurDiscount(cart) {
    const code = DISCOUNT_CODE.toUpperCase();
    const cartText = JSON.stringify(cart || {}).toUpperCase();
    const pills = [...document.querySelectorAll('.cart-discount__pill[data-discount-code]')];
    const domHasCode = pills.some(el => String(el.dataset.discountCode || '').toUpperCase() === code);
    return cartText.includes(code) || domHasCode;
  }

  function syncDiscountState(cart) {
    const applied = !!cart?.item_count && cartHasOurDiscount(cart);
    ourDiscountApplied = applied;
    if (applied) localStorage.setItem('tl_discount_applied', '1');
    else localStorage.removeItem('tl_discount_applied');

    if (applied) {
      document.querySelectorAll('.tl-offer-card--cart,.tl-offer-card--product').forEach(n => n.remove());
      const bar = root.querySelector('[data-tl-bar]');
      if (bar) bar.hidden = true;
    }
    return applied;
  }

  async function mountCartOffer(force = false) {
    if (cartMountBusy) return;
    const summary = document.querySelector('.cart-drawer__summary');
    if (!summary) return;

    cartMountBusy = true;
    try {
      cleanupDuplicates('.tl-offer-card--cart');
      const cart = await getCart();
      if (!cart || !cart.item_count) {
        ourDiscountApplied = false;
        localStorage.removeItem('tl_discount_applied');
        document.querySelectorAll('.tl-offer-card--cart').forEach(n => n.remove());
        return;
      }

      if (syncDiscountState(cart)) return;

      const mode = personalIsActive() ? 'personal' : null;
      if (!mode) return;

      cleanupDuplicates('.tl-offer-card--cart');
      const existing = document.querySelector('.tl-offer-card--cart');
      if (existing && existing.dataset.mode === mode && existing.closest('.cart-drawer__summary') === summary) return;
      document.querySelectorAll('.tl-offer-card--cart').forEach(n => n.remove());

      const expiry = mode === 'personal' ? getPersonalExpiry() : cycleExpiry;
      const card = cloneOfferCard(mode, expiry, 'cart');
      if (!card) return;
      card.classList.add('tl-offer-card--cart');
      card.dataset.mode = mode;
      summary.prepend(card);
      pushEvent('cart_offer_shown', { mode });
    } finally {
      cartMountBusy = false;
    }
  }

  function renderGlobalBar() {
    const bar = root.querySelector('[data-tl-bar]');
    const title = root.querySelector('[data-tl-bar-title]');
    const subtitle = root.querySelector('[data-tl-bar-subtitle]');
    const cta = root.querySelector('[data-tl-bar-cta]');
    if (!bar || !title || !subtitle || !cta) return;

    if (ourDiscountApplied) {
      bar.hidden = true;
      return;
    }

    if (!personalIsActive()) {
      bar.hidden = true;
      return;
    }

    title.textContent = 'Size özel %' + DISCOUNT_PERCENT + ' avantaj aktif';
    subtitle.textContent = 'Kalan süre: ' + formatTime(getPersonalExpiry() - Date.now());
    cta.textContent = 'Avantajı uygula';
    cta.href = discountUrl();

    bar.hidden = false;
    root.hidden = false;
  }

  function hydrateHomeCampaign() {
    const section = document.querySelector('[data-tl-campaign-home]');
    if (!section) return;

    const cards = [...section.querySelectorAll('[data-tl-campaign-card]')];
    selectedHandles = cards.map(card => card.dataset.handle).filter(Boolean);

    cards.forEach(card => {
      const price = Number(card.dataset.canvasPrice || 0) / 100;
      const size = card.dataset.canvasSize || '';
      const prices = card.querySelector('[data-tl-campaign-prices]');
      const badge = card.querySelector('[data-tl-campaign-badge]');
      const caption = card.querySelector('[data-tl-campaign-caption]');

      if (badge) {
        badge.textContent = personalIsActive()
          ? '%' + DISCOUNT_PERCENT + ' · SİZE ÖZEL'
          : '48 SAATLİK SEÇKİ';
      }

      if (prices && price) {
        if (personalIsActive()) {
          const discounted = price * (1 - Number(DISCOUNT_PERCENT) / 100);
          prices.innerHTML =
            '<span class="tl-campaign-card__old">' + formatTry(price) + '</span>' +
            '<strong>' + formatTry(discounted) + '</strong>';
        } else {
          prices.innerHTML = '<strong>' + formatTry(price) + '</strong>';
        }
      }

      if (caption) {
        caption.textContent = (size ? size + ' Kanvas' : 'Kanvas') +
          (personalIsActive() ? ' · Size özel fiyat' : '');
      }

      if (!card.dataset.tlBound) {
        card.dataset.tlBound = '1';
        card.addEventListener('click', () => {
          localStorage.setItem('tl_last_campaign_handle', card.dataset.handle || '');
          localStorage.setItem('tl_last_campaign_cycle', String(Math.floor(Date.now() / CYCLE_DURATION)));
          pushEvent('campaign_product_click', { handle: card.dataset.handle || '' });
        });
      }
    });

    section.hidden = false;
  }

  function updateTimers() {
    const expiry = getPersonalExpiry();
    if (expiry && Date.now() >= expiry) {
      localStorage.setItem('tl_offer_expired', '1');
      localStorage.removeItem('tl_offer_start');
      document.querySelectorAll('[data-tl-offer-card][data-mode="personal"]').forEach(n => n.remove());
      hydrateHomeCampaign();
      clearMainProductPrice();
      mountProductOffer(true);
      mountCartOffer(true);
      renderGlobalBar();
    }

    document.querySelectorAll('[data-tl-countdown]').forEach(el => {
      const target = Number(el.dataset.expiry || 0);
      el.textContent = formatTime(target - Date.now());
    });

    document.querySelectorAll('[data-tl-home-countdown]').forEach(el => {
      el.textContent = formatTime(cycleExpiry - Date.now());
    });

    const subtitle = root.querySelector('[data-tl-bar-subtitle]');
    if (subtitle && !root.querySelector('[data-tl-bar]')?.hidden) {
      subtitle.textContent = personalIsActive()
        ? 'Kalan süre: ' + formatTime(getPersonalExpiry() - Date.now())
        : 'Seçki yenileniyor: ' + formatTime(cycleExpiry - Date.now());
    }
  }

  async function loadRotation() {
    document.querySelectorAll('product-price > .tl-main-offer-price').forEach(n => n.remove());
    hydrateHomeCampaign();
    const initialCart = await getCart();
    syncDiscountState(initialCart);
    renderGlobalBar();
    hydrateMainProductPrice();
    mountProductOffer();
    mountCartOffer();
    root.hidden = false;
    pushEvent('campaign_loaded', {
      cycle: Math.floor(Date.now() / CYCLE_DURATION),
      count: document.querySelectorAll('[data-tl-campaign-card]').length
    });
  }

  let observerQueued = false;
  const observer = new MutationObserver(() => {
    if (observerQueued) return;
    observerQueued = true;
    requestAnimationFrame(() => {
      observerQueued = false;
      mountProductOffer();
      mountCartOffer();
      cleanupDuplicates('.tl-offer-card--cart');
      cleanupDuplicates('.tl-offer-card--product');
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const inVariantPicker = !!target.closest('variant-picker');
    const inCustomSize = !!target.closest('.tablissa-custom-size');
    const inProductForm = !!target.closest('product-form-component');
    if (!inVariantPicker && !inCustomSize && !inProductForm) return;

    const directVariantId = Number(target?.dataset?.variantId || 0);
    if (directVariantId) {
      tlResolvedVariantId = directVariantId;
      tlResolvedPriceCents = 0;
    }

    setTimeout(() => {
      const customOpen = !!document.querySelector('.tablissa-custom-size__panel:not([hidden])');
      const urlId = Number(new URL(window.location.href).searchParams.get('variant') || 0);
      // Do not overwrite a newly selected standard variant with a stale URL variant.
      const formId = Number(document.querySelector('product-form-component input[name="id"]')?.value || 0);
      if (!customOpen && (formId || urlId)) {
        tlResolvedVariantId = formId || urlId;
        tlResolvedPriceCents = 0;
      }

      const card = document.querySelector('.tl-offer-card--product');
      const productTarget = document.querySelector('product-form-component');
      if (card && productTarget) hydrateProductOfferPricing(card, productTarget);
      hydrateMainProductPrice(productTarget);
    }, 750);
  });

  window.addEventListener('tablissa:custom-size-price', event => {
    const detail = event?.detail || {};
    const variantId = Number(detail.variantId || 0);
    const priceCents = Number(detail.priceCents || 0);

    if (variantId) tlResolvedVariantId = variantId;
    if (priceCents > 0) tlResolvedPriceCents = priceCents;

    setTimeout(() => {
      const card = document.querySelector('.tl-offer-card--product');
      const productTarget = document.querySelector('product-form-component');
      if (card && productTarget) hydrateProductOfferPricing(card, productTarget);
      hydrateMainProductPrice(productTarget);
    }, 30);
  });

  window.addEventListener('tablissa:custom-size-closed', event => {
    const previousId = Number(event?.detail?.variantId || 0);
    const urlId = Number(new URL(window.location.href).searchParams.get('variant') || 0);

    tlResolvedVariantId = previousId || urlId || 0;
    tlResolvedPriceCents = 0;

    setTimeout(() => {
      const card = document.querySelector('.tl-offer-card--product');
      const productTarget = document.querySelector('product-form-component');
      if (card && productTarget) hydrateProductOfferPricing(card, productTarget);
      hydrateMainProductPrice(productTarget);
    }, 80);
  });

  window.addEventListener('tablissa:theme-price-updated', event => {
    const variantId = Number(event?.detail?.variantId || 0);

    if (variantId) {
      tlResolvedVariantId = variantId;
      tlResolvedPriceCents = 0;
    }

    requestAnimationFrame(() => {
      const card = document.querySelector('.tl-offer-card--product');
      const productTarget = document.querySelector('product-form-component');

      if (card && productTarget) {
        hydrateProductOfferPricing(card, productTarget);
      }

      hydrateMainProductPrice(productTarget);
    });
  });

  document.addEventListener('click', event => {
    const actionable = event.target.closest('button, a, input[type="submit"]');
    if (actionable) localStorage.setItem('tl_last_activity', String(Date.now()));

    const discountRemove = event.target.closest('.cart-discount__pill-remove');
    if (discountRemove) {
      setTimeout(async () => {
        const cart = await getCart();
        syncDiscountState(cart);
        renderGlobalBar();
        mountProductOffer(true);
        mountCartOffer(true);
      }, 500);
    }

  }, { passive: true });

  setInterval(updateTimers, 1000);
  loadRotation();
})();